import React from "react";
import styled from "styled-components";
import { Card } from "@120wateraudit/waterworks";

const SectionTitle = styled.p`
  font-weight: 600;
  margin-bottom: 0.75rem;
`;

const Field = styled.p`
  margin: 0.25rem 0;
  color: #374151;
`;

const Label = styled.span`
  font-weight: 500;
  color: #6b7280;
`;

const Value = styled.span`
  font-weight: 600;
  color: #111827;
`;

interface UtilityInfoProps {
  pwsId: string;
  counties: string[];
  state: string;
  segments?: string[];
  pwsType: string;
  owner: string;
  population: number;
  serviceLines: number;
}

export default function UtilityInfoCard({
  pwsId,
  counties,
  state,
  segments,
  pwsType,
  owner,
  population,
  serviceLines,
}: UtilityInfoProps): JSX.Element {
  return (
    <Card style={{ height: "100%" }}>
      <SectionTitle>Utility Information</SectionTitle>
      <Field>
        <Label>PWS ID:</Label> <Value>{pwsId}</Value>
      </Field>
      <Field>
        <Label>Counties Served:</Label> <Value>{counties.join(", ")}</Value>
      </Field>
      <Field>
        <Label>State / Primacy Code:</Label> <Value>{state}</Value>
      </Field>
      {segments && (
        <Field>
          <Label>Segments:</Label> <Value>{segments.join(", ")}</Value>
        </Field>
      )}

      <br />
      <SectionTitle>SDWIS Information</SectionTitle>
      <Field>
        <Label>PWS Type:</Label> <Value>{pwsType}</Value>
      </Field>
      <Field>
        <Label>Owner:</Label> <Value>{owner}</Value>
      </Field>
      <Field>
        <Label>Population:</Label> <Value>{population}</Value>
      </Field>
      <Field>
        <Label>Service Line Connections:</Label> <Value>{serviceLines}</Value>
      </Field>
    </Card>
  );
}
